import React from "react";
import PropTypes from "prop-types";

const ContactSettings = ({ contactData, setContactData, t_controls }) => {
  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setContactData((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="card mt-3">
      <div className="card-body">
        <h5 className="card-title">{t_controls.contact_settings || "Contact Info"}</h5>

        <div className="form-group mt-2">
          <label htmlFor="contactName">{t_controls.contact_name || "Contact Name"}</label>
          <input
            type="text"
            className="form-control"
            id="contactName"
            value={contactData.contact_name || ""}
            placeholder={t_controls.contact_name || "Contact Name"}
            onChange={handleChange("contact_name")}
          />
        </div>

        <div className="form-group mt-2">
          <label htmlFor="contactTelephone">{t_controls.contact_telephone || "Contact Telephone"}</label>
          <input
            type="text"
            className="form-control"
            id="contactTelephone"
            value={contactData.contact_telephone || ""}
            placeholder={t_controls.contact_telephone || "Contact Telephone"}
            onChange={handleChange("contact_telephone")}
          />
        </div>

        <div className="form-group mt-2">
          <label htmlFor="contactEmail">{t_controls.contact_email || "Contact Email"}</label>
          <input
            type="email"
            className="form-control"
            id="contactEmail"
            value={contactData.contact_email || ""}
            placeholder={t_controls.contact_email || "Contact Email"}
            onChange={handleChange("contact_email")}
          />
        </div>

        <div className="form-group mt-2">
          <label htmlFor="footerContactEmail">{t_controls.footer_contact_email || "Footer Contact Email"}</label>
          <input
            type="email"
            className="form-control"
            id="footerContactEmail"
            value={contactData.footer_contact_email || ""}
            placeholder={t_controls.footer_contact_email || "Footer Contact Email"}
            onChange={handleChange("footer_contact_email")}
          />
        </div>
      </div>
    </div>
  );
};

ContactSettings.propTypes = {
  contactData: PropTypes.object.isRequired,
  setContactData: PropTypes.func.isRequired,
  t_controls: PropTypes.object.isRequired,
};

export default ContactSettings;
